import { useLocation } from 'react-router-dom';

// Toggle this flag to show/hide the site-wide maintenance banner.
// Change SHOW to false and rebuild to remove.
const SHOW = false;
const MESSAGE = '🛠 Scheduled maintenance today 9am – 5pm — your course progress is saved automatically.';

export default function MaintenanceBanner() {
  const location = useLocation();
  if (!SHOW) return null;
  // Hide on the full-screen course player so it doesn't disrupt learning
  if (location.pathname.startsWith('/course/')) return null;
  return (
    <div style={styles.banner} role="status">
      <div className="container" style={styles.inner}>
        <span style={styles.text}>{MESSAGE}</span>
      </div>
    </div>
  );
}

const styles = {
  banner: {
    background: 'linear-gradient(90deg, #b39e89 0%, #d4c5ad 100%)',
    borderBottom: '1px solid #a08770',
    color: '#3a2e1f',
    fontSize: 14,
    fontWeight: 600,
    padding: '10px 0',
    textAlign: 'center',
    position: 'relative',
    zIndex: 101,
  },
  inner: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, flexWrap: 'wrap' },
  text: { lineHeight: 1.4 },
};
